type PropsType = {
  callerName: string
}

const CallerNameContainer = (props: PropsType) => {
  return (
    <p className="text-center mx-auto w-full mb-4 text-[#5f5f5f] font-normal text-base leading-[46px] -mt-3">
      {props.callerName}
    </p>
  )
}

export default CallerNameContainer
